import { render, staticRenderFns } from "./EditSegmentOrTagModal.vue?vue&type=template&id=feb6b7fc&scoped=true&"
import script from "./EditSegmentOrTagModal.vue?vue&type=script&lang=js&"
export * from "./EditSegmentOrTagModal.vue?vue&type=script&lang=js&"
import style0 from "./EditSegmentOrTagModal.vue?vue&type=style&index=0&id=feb6b7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb6b7fc",
  null
  
)

export default component.exports